import { CtaLink } from "@/components/Ui";
import { PATIENTS } from "@/content/site";

export const TerritoryCta = () => (
  <section className="on-dark bg-ink text-ivory" aria-labelledby="territory-heading" data-testid="territory-cta">
    <div className="wrap flex flex-col items-start gap-8 py-14 md:flex-row md:items-center md:justify-between md:py-16">
      <div>
        <p className="eyebrow mb-4">Territories</p>
        <h2 id="territory-heading" className="h2 text-ivory">Check Territory Availability</h2>
      </div>
      <CtaLink to="/contact?intent=territory" id="view-available-territories">View Available Territories</CtaLink>
    </div>
  </section>
);

export const BrochureCta = () => (
  <section className="border-y border-gold/40 bg-white" aria-label="Franchise overview request" data-testid="brochure-cta">
    <div className="wrap flex flex-col items-start gap-6 py-12 md:flex-row md:items-center md:justify-between">
      <p className="font-display text-lg font-semibold uppercase tracking-[0.06em] md:text-xl">
        {PATIENTS.brochure1}<br /><span className="text-gold-deep">{PATIENTS.brochure2}</span>
      </p>
      <CtaLink to="/contact?intent=overview" id="brochure-request-overview" variant="ink">Request Franchise Overview</CtaLink>
    </div>
  </section>
);
